import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        VDialog,
        {
          attrs: { width: _vm.width, persistent: true, scrollable: "" },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                {
                  staticClass: "grey lighten-3",
                  attrs: { "primary-title": "" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.title ? _vm.title : _vm.$t("common.confirmation")
                      ) +
                      " "
                  ),
                  _c(
                    VBtn,
                    {
                      staticClass: "close",
                      staticStyle: { position: "absolute", right: "15px" },
                      attrs: { icon: "" },
                      on: { click: _vm.onClose },
                    },
                    [_c(VIcon, [_vm._v("icon-decline")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                { staticClass: "pb-0 pt-2" },
                [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.text
                          ? _vm.text
                          : "¿Esta seguro de realizar la operación?"
                      )
                    ),
                  ]),
                  _vm._t("body"),
                ],
                2
              ),
              _c(VDivider),
              _vm.showButtons
                ? _c(
                    VCardActions,
                    { staticClass: "text-center d-block" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "default",
                          attrs: { text: "", outlined: "" },
                          on: {
                            click: function ($event) {
                              return _vm.onConfirm(false)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.no_text) + " ")]
                      ),
                      _c(
                        VBtn,
                        {
                          attrs: {
                            color: "primary",
                            disabled: _vm.disableSiButton,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onConfirm(true)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.si_text) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }